// Dexie store outbox_actions (P8.G, ADR 0008 §10).
// Persiste les mutations qui ont echoue cote reseau pour rejeu au retour
// online. La cle Idempotency-Key est generee a l'enqueue, le backend
// (CLAUDE §6.7) garantit que rejouer le meme key est safe.

import Dexie, { type EntityTable } from "dexie";

export type OutboxMethod = "POST" | "PUT" | "PATCH" | "DELETE";

export interface OutboxAction {
  id: string;
  method: OutboxMethod;
  url: string;
  body: string | null;
  idempotency_key: string;
  created_at: string;
  retries: number;
  last_error: string | null;
}

class OutboxDatabase extends Dexie {
  outboxActions!: EntityTable<OutboxAction, "id">;
  constructor() {
    super("mailregent-offline");
    this.version(1).stores({ outboxActions: "id, created_at" });
  }
}

const db = new OutboxDatabase();

export const outboxDb = {
  async add(
    item: Omit<OutboxAction, "id" | "retries" | "last_error" | "created_at">,
  ): Promise<string> {
    const id = crypto.randomUUID();
    await db.outboxActions.add({
      id,
      ...item,
      retries: 0,
      last_error: null,
      created_at: new Date().toISOString(),
    });
    return id;
  },

  async list(): Promise<OutboxAction[]> {
    return db.outboxActions.orderBy("created_at").toArray();
  },

  async count(): Promise<number> {
    return db.outboxActions.count();
  },

  async remove(id: string): Promise<void> {
    await db.outboxActions.delete(id);
  },

  async markFailed(id: string, error: string): Promise<void> {
    await db.outboxActions
      .where("id")
      .equals(id)
      .modify((a) => {
        a.retries = (a.retries ?? 0) + 1;
        a.last_error = error;
      });
  },

  async clear(): Promise<void> {
    await db.outboxActions.clear();
  },
};
